export default "__VITE_ASSET__a300bcd7__"